import { FragmentStore } from '../runtime/stores/fragment'
import artifact from '$houdini/artifacts/UserAccountFields'


// create the fragment store

export class UserAccountFieldsStore extends FragmentStore {
	constructor() {
		super({
			artifact,
			storeName: "UserAccountFieldsStore",
			variables: true,
			
		})
	}
}
